/**
 * Сортировка таблицы
 */
(function($) {

    $.fn.sortTable = function(options) {

        var option = $.extend({
            'secondSort': 'price',
            'thirdSort': 'quantity'
        }, options);

        return this.each(function () { //Для каждой таблицы

            var $table = $(this);
            var sliceColsValue  = $table.find("tbody tr:first td[rowspan]").length;
            if (!$(this).is("table")) { //Если элемент не таблица
                console.error("element is not table");
                return
            }

            //Обработчик для кнопки сортировки
            $("a[data-sort]", $table).on("click", function () {

                var $sort = $(this), //Кнопка сортировки
                    $sortRow = $sort.closest("tr"), //Строка сортировки
                    sortType = $sort.data("sort"); //Параметр который будет выполняться сортировка

                //Определить по возрастанию или по убиванию
                var asc = $sort.hasClass("goods-table-sort__sort-up") ? true : false; //

                $sort
                    .removeClass("goods-table-sort__sort-down")
                    .removeClass("goods-table-sort__sort-up");

                if (asc) $sort.addClass("goods-table-sort__sort-down");
                else $sort.addClass("goods-table-sort__sort-up");

                //След строка после строки находящий кнопки сортировки
                var sortStartIndex = $("tr", $table).index($sortRow) + 1;

                var rows = [],
                    rowsIndex = 0;
                var hiddenArray = [];
                //Все строки начиная после строки сортировки
                $("tr", $table).slice(sortStartIndex).each(function(){
                    var trThis = $(this);
                    if (rows[rowsIndex - 1] && (rows[rowsIndex - 1].colsLegnth - sliceColsValue == $("td", trThis).length)) {

                        //Строки входить в подгруппу предыдущий строки

                        var cols = []

                        $("td", trThis).each(function(){
                            cols.push($(this));
                        })

                        var aValue = null,
                            secondValue = null,
                            thirdValue = null;

                        for(var i = 0; i < cols.length; i++){
                            if ($("[data-" + sortType + "]", cols[i]).length)
                                aValue = $("[data-" + sortType + "]", cols[i]).data(sortType)
                            if ($("[data-" + option["secondSort"] + "]", cols[i]).length)
                                secondValue = $("[data-" + option["secondSort"] + "]", cols[i]).data(option["secondSort"])
                            if ($("[data-" + option["thirdSort"] + "]", cols[i]).length)
                                thirdValue = $("[data-" + option["thirdSort"] + "]", cols[i]).data(option["thirdSort"])
                        }

                        var result = [];

                        result.obj = cols;
                        result.aValue = aValue;
                        result.secondValue = secondValue;
                        result.thirdValue = thirdValue;

                        rows[rowsIndex - 1].cols.push(result);
                    } else {
                        var tdInTrThis = trThis.find("td[rowspan]");
                        rows[rowsIndex] = [];
                        $.each(tdInTrThis,function(i){
                            rows[rowsIndex][i] = $(this);
                        });
                        rows[rowsIndex].colsLegnth = trThis.find("td").length;
                        //Новая строка не входящий в группировку

                        var cols = [];

                        $("td", trThis).slice(sliceColsValue).each(function(){
                            cols.push($(this));
                        })


                        var aValue = null,
                            secondValue = null,
                            thirdValue = null;

                        for(var i = 0; i < cols.length; i++){
                            if ($("[data-" + sortType + "]", cols[i]).length)
                                aValue = $("[data-" + sortType + "]", cols[i]).data(sortType)
                            if ($("[data-" + option["secondSort"] + "]", cols[i]).length)
                                secondValue = $("[data-" + option["secondSort"] + "]", cols[i]).data(option["secondSort"])
                            if ($("[data-" + option["thirdSort"] + "]", cols[i]).length)
                                thirdValue = $("[data-" + option["thirdSort"] + "]", cols[i]).data(option["thirdSort"])
                        }

                        var result = [];

                        result.obj = cols;
                        result.aValue = aValue;
                        result.secondValue = secondValue;
                        result.thirdValue = thirdValue;
                        rows[rowsIndex].cols = [];
                        rows[rowsIndex].cols.push(result);

                        rowsIndex++;

                    }

                })

                //Сортируем подгруппы
                for(var i = 0; i < rows.length; i++) {
                    for(var n = 0; n < rows[i].cols.length - 1; n++) {
                        for(var m = n + 1; m < rows[i].cols.length; m++) {
                            if (tableRowsCompare(rows[i].cols[n], rows[i].cols[m], asc, sortType, option) > 0) {
                                var tmp = rows[i].cols[n];
                                rows[i].cols[n] = rows[i].cols[m];
                                rows[i].cols[m] = tmp;
                            }
                        }
                    }
                    /*rows[i].cols.sort(function(a, b) {
                        return tableRowsCompare(a, b, asc, sortType, option)
                    });*/
                }

                //Сортируем строки которые не входить в подгруппы
                for(var n = 0; n < rows.length - 1; n++) {
                    for(var m = n + 1; m < rows.length; m++) {
                        if (tableRowsCompare(rows[n].cols[0], rows[m].cols[0], asc, sortType, option) > 0) {
                            var tmp = rows[n];
                            rows[n] = rows[m];
                            rows[m] = tmp;
                        }
                    }
                }
                /*rows.sort(function(a, b){
                    return tableRowsSort(a.cols[0], b.cols[0], asc, sortType, option)
                })*/

                //Очищаем строки
                $("tr", $table).slice(sortStartIndex).each(function() {
                    $("td", $(this)).remove()
                });

                //Добавляем сортированный строки
                var pos = sortStartIndex;
                for(var i = 0; i < rows.length; i++) {
                    var row = rows[i];
                    var eqPos = $("tr", $table);
                    eqPos.addClass("stopHidding");
                    var rowSpanVal = 0;
                    $.each(row,function(){
                        eqPos.eq(pos).append($(this));
                        if(rowSpanVal==0){
                            rowSpanVal = parseInt($(this).attr("rowspan"));
                        }
                    });
                    // eqPos.append(row.name).append(row.article).append(row.brand);
                    for(j = 0; j < row.cols.length; j++) {
                        if(rowSpanVal>0){
                            eqPos.eq(pos).addClass("NEKO").removeClass("hidden");
                        }else{
                            eqPos.eq(pos).addClass("hidden");
                        }
                        eqPos.eq(pos).append(row.cols[j].obj);
                        pos++;
                        rowSpanVal = rowSpanVal-1;
                    }
                }

                return false;

            });

        });

    }

    function tableRowsCompare(a, b, asc, sortType, option) {

        var aValue = a.aValue,
            bValue = b.aValue,
            secondAValue = a.secondValue,
            secondBValue = b.secondValue,
            thirdAValue = a.thirdValue,
            thirdBValue = b.thirdValue

        if (aValue == bValue) {
            if (secondAValue != secondBValue) {
                aValue = secondAValue
                bValue = secondBValue
            } else {
                aValue = thirdAValue
                bValue = thirdBValue
            }
        }
        if (asc) {
            var tmp = aValue;
            aValue = bValue;
            bValue = tmp
        }

        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;

    }

})(jQuery);